module.exports = __webpack_public_path__ + "static/media/my-virtual-courses-empty-state.8cdf0442.svg";